import { getRewardfulReferral } from "../../utils/rewardful";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { axiosInstance } from "../../config";
import "./RussellOfferModal.css";

const RussellOfferModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation('upgrade');
  const [loading, setLoading] = useState(false);
  const [interval, setInterval] = useState("monthly");

  if (!isOpen) return null;

  const isAnnual = interval === "annual";
  const originalPrice = isAnnual ? 69 : 81;
  const discountedPrice = Math.round(originalPrice * 0.9 * 100) / 100;
  const periodLabel = isAnnual ? t('perMonthShort') : t('perMonth');

  const handleClaim = async () => {
    setLoading(true);
    try {
      const referral = getRewardfulReferral();
      const res = await axiosInstance.post("/billing/plan/checkout", {
        interval,
        coupon: "RUSSELL",
        ...(referral ? { referral } : {}),
      });
      if (res.data?.url) {
        window.location.href = res.data.url;
      }
    } catch (err) {
      console.error("Checkout error:", err);
      setLoading(false);
    }
  };

  return (
    <div className="russell-modal-overlay" onClick={onClose}>
      <div className="russell-modal" onClick={(e) => e.stopPropagation()}>
        <button className="russell-modal-close" onClick={onClose}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        {/* Russell Brand photo */}
        <div className="russell-modal-photo">
          <img
            src="/russell-brand.jpg"
            alt="Russell Brand"
            onError={(e) => {
              e.target.style.display = "none";
              e.target.parentElement.classList.add("russell-modal-photo--fallback");
            }}
          />
        </div>

        <div className="russell-modal-badge">{t('exclusiveOffer')}</div>

        <h3 className="russell-modal-title">{t('russellBrandsPick')}</h3>
        <p className="russell-modal-subtitle">
          {t('get10PercentOff')}
        </p>

        {/* Billing interval toggle */}
        <div className="russell-modal-toggle">
          <button
            className={`russell-modal-toggle-btn${!isAnnual ? " active" : ""}`}
            onClick={() => setInterval("monthly")}
          >
            {t('monthly')}
          </button>
          <button
            className={`russell-modal-toggle-btn${isAnnual ? " active" : ""}`}
            onClick={() => setInterval("annual")}
          >
            {t('annual')}
            <span className="russell-modal-save-badge">{t('save15Percent')}</span>
          </button>
        </div>

        <div className="russell-modal-price">
          <span className="russell-modal-original">${originalPrice}</span>
          <span className="russell-modal-amount">${discountedPrice}</span>
          <span className="russell-modal-period">{periodLabel}</span>
        </div>
        <p className="russell-modal-discount-note">{t('discountApplied')}</p>

        <ul className="russell-modal-features">
          <li>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            {t('upload30Videos')}
          </li>
          <li>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            {t('upTo2Hours')}
          </li>
          <li>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            {t('generate300Clips')}
          </li>
          <li>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            {t('downloadAndSchedule')}
          </li>
        </ul>

        <button
          className="russell-modal-btn"
          onClick={handleClaim}
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="russell-modal-spinner" />
              {t('redirecting')}
            </>
          ) : (
            t('claim10Off')
          )}
        </button>

        <button className="russell-modal-dismiss" onClick={onClose}>
          {t('noThanksFullPrice')}
        </button>
      </div>
    </div>
  );
};

export default RussellOfferModal;
